import IconDark from '@Resources/assets/icons/dark/notification.svg';
import IconLight from '@Resources/assets/icons/light/notification.svg';
import { Badge, SvgIcon } from '@mui/material';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from '../../Header.scss';

const NotificationIcon = (props) => {
    const { hasUnreadNotifications, isSelected } = props;

    return (
        <Badge
            variant="dot"
            color="error"
            overlap="circular"
            badgeContent={hasUnreadNotifications ? ' ' : 0}
            sx={{
                '.MuiBadge-dot': {
                    right: '8%',
                },
            }}
        >
            <SvgIcon inheritViewBox>
                {isSelected ? <IconLight /> : <IconDark />}
            </SvgIcon>
        </Badge>
    );
};

NotificationIcon.propTypes = {
    hasUnreadNotifications: PropTypes.bool,
    isSelected: PropTypes.bool,
};
export default NotificationIcon;
